import { FC } from 'react';
import styled, { css } from 'styled-components';

export type MessageProps = {
  isLarge: boolean;
};

const maxSize = 500;

const avatarMessageTextStyles = css`
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  margin-top: 16px;
`;

const Error = styled.div`
  color: rgb(241, 57, 52);
  ${avatarMessageTextStyles};
`;

const FileRequirement = styled.div`
  color: #919eaa;
  ${avatarMessageTextStyles};
`;

const Message: FC<MessageProps> = ({ isLarge }) =>
  isLarge ? (
    <Error>Your image is larger than {maxSize} KB.</Error>
  ) : (
    <FileRequirement>Max size {maxSize} KB .jpg, .jpeg or .png</FileRequirement>
  );

export default Message;
